module.exports = __webpack_public_path__ + "img/joyfulicon1.524b65df.png";